var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.1167C22.732 29.1167 29 22.8487 29 15.1167C29 7.38471 22.732 1.1167 15 1.1167C7.26801 1.1167 1 7.38471 1 15.1167C1 22.8487 7.26801 29.1167 15 29.1167Z",
    fill: "white",
    stroke: "#612AFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25105 9.36775C9.58579 9.03302 10.1285 9.03302 10.4632 9.36775L15 13.9045L19.5368 9.36775C19.8715 9.03302 20.4142 9.03302 20.7489 9.36775C21.0837 9.70249 21.0837 10.2452 20.7489 10.5799L16.2122 15.1167L20.7489 19.6535C21.0837 19.9882 21.0837 20.5309 20.7489 20.8656C20.4142 21.2004 19.8715 21.2004 19.5368 20.8656L15 16.3289L10.4632 20.8656C10.1285 21.2004 9.58579 21.2004 9.25105 20.8656C8.91632 20.5309 8.91632 19.9882 9.25105 19.6535L13.7878 15.1167L9.25105 10.5799C8.91632 10.2452 8.91632 9.70249 9.25105 9.36775Z",
    fill: "#612AFF",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastings);
export default __webpack_public_path__ + "static/media/fastings.ee6820cef3a11ff35529cca0b9460b88.svg";
export { ForwardRef as ReactComponent };